const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27.772} height={30} {...props}>
    <g data-name="Group 6531">
      <path
        data-name="Path 5759"
        d="m24.428 24.95-7.2 4.156a6.69 6.69 0 0 1-6.689 0l-7.2-4.156a6.689 6.689 0 0 1-3.344-5.793v-8.311a6.689 6.689 0 0 1 3.344-5.793l7.2-4.156a6.689 6.689 0 0 1 6.689 0l7.2 4.156a6.689 6.689 0 0 1 3.345 5.793v8.311a6.689 6.689 0 0 1-3.345 5.793Z"
        fill="#ffc400"
      />
      <path
        data-name="Path 5763"
        d="M23.158 24.27a6.772 6.772 0 0 1-1.923 1.345 6.772 6.772 0 0 1-2.129.989 6.779 6.779 0 0 1 1.921-1.349 6.766 6.766 0 0 1 2.131-.985Z"
        fill="#ffc400"
      />
      <path
        data-name="Path 5764"
        d="M7.406 25.791a4.283 4.283 0 0 1-1.6-.711c-.832-.48-1.466-.941-1.415-1.028a4.289 4.289 0 0 1 1.6.711c.831.48 1.466.94 1.415 1.028Z"
        fill="#ffc400"
      />
      <path
        data-name="Path 5765"
        d="M10.585 2.382c.067.116-.575.613-1.435 1.11s-1.612.8-1.679.688.575-.613 1.435-1.11 1.612-.801 1.679-.688Z"
        fill="#ffc400"
      />
      <path
        data-name="Path 7825"
        d="M8.499 23.019a1.952 1.952 0 0 1-1.95-1.95V9.619A1.753 1.753 0 0 1 8.3 7.868h8.834a.312.312 0 0 1 .221.533l-1.806 1.811a.312.312 0 0 1-.221.091H8.983v10.282h10.282v-5.856a.312.312 0 0 1 .091-.221l1.81-1.81a.312.312 0 0 1 .533.221v8.151a1.952 1.952 0 0 1-1.95 1.95Zm6.024-5.306 7.037-7.038a.3.3 0 0 0 0-.423l-2-2a.3.3 0 0 0-.423 0l-7.039 7.036a.3.3 0 0 0 0 .423l2 2a.3.3 0 0 0 .423 0m8.215-8.215 1.045-1.044a.425.425 0 0 0 0-.6l-1.824-1.823a.425.425 0 0 0-.6 0l-1.045 1.044a.425.425 0 0 0 0 .6l1.825 1.825a.425.425 0 0 0 .6 0m-11.338 9.083 3.009-.806a.139.139 0 0 0 .062-.232l-2.2-2.2a.139.139 0 0 0-.232.062l-.806 3.009a.139.139 0 0 0 .17.17"
      />
      <path data-name="Rectangle 2545" fill="none" d="M6.549 5.903h17.357v17.115H6.549z" />
    </g>
  </svg>
);

export default SvgComponent;
